<template>
  <div class="blog-section">
    <div class="blog-container">

      <!-- 左侧：文章列表 (根据分页动态展示) -->
      <div class="main-content">
        <div v-for="post in paginatedPosts" :key="post.id" class="post-card">

          <!-- 文章头部信息 (带图标) -->
          <div class="post-header">
            <span class="meta-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
              Fraud Counsel Department
            </span>
            <span class="meta-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z">
                </path>
              </svg>
              Comments (0)
            </span>
            <span class="meta-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              {{ post.date }}
            </span>
          </div>

          <h2 class="post-title">{{ post.title }}</h2>
          <p class="post-excerpt">{{ post.excerpt }} [...]</p>

          <button @click="navTo(post.url)" class="read-more">Read More <span class="arrow">→</span></button>
        </div>
      </div>

      <!-- 右侧：侧边栏 -->
      <aside class="sidebar">

        <!-- 顶部搜索 -->
        <div class="sidebar-box search-top">
          <div class="search-bar">
            <input type="text" placeholder="Search" />
            <button>🔍</button>
          </div>
        </div>

        <div class="sidebar-box">
          <h3>RECENT POSTS</h3>
          <ul class="link-list">
            <li v-for="post in recentPosts" :key="'rp-' + post.id">{{ post.title }}</li>
          </ul>
        </div>

        <div class="sidebar-box">
          <h3>RECENT COMMENTS</h3>
          <p class="empty-text">No comments to show</p>
        </div>

        <div class="sidebar-box">
          <h3>ARCHIVES</h3>
          <ul class="link-list">
            <li v-for="archive in archives" :key="archive">{{ archive }}</li>
          </ul>
        </div>

        <div class="sidebar-box">
          <h3>CATEGORIES</h3>
          <ul class="link-list">
            <li>Uncategorized</li>
          </ul>
        </div>

        <!-- 中间搜索 -->
        <div class="sidebar-box search-mid">
          <h3>SEARCH</h3>
          <div class="search-bar">
            <input type="text" placeholder="Search..." />
            <button>🔍</button>
          </div>
        </div>

        <!-- 底部推荐列表 -->
        <div class="sidebar-box">
          <h3>RECENT POST</h3>
          <ul class="link-list with-date">
            <li v-for="post in recentPosts" :key="'rd-' + post.id">
              <div class="post-title-sm">{{ post.title }}</div>
              <div class="post-date-sm">{{ post.date }}</div>
            </li>
          </ul>
        </div>

        <div class="sidebar-box">
          <h3>CATEGORIES</h3>
          <ul class="link-list">
            <li>Uncategorized <span class="count">(50)</span></li>
          </ul>
        </div>

      </aside>

    </div>

    <!-- 底部分页器 (保留联动功能) -->
    <div class="pagination-wrapper">
      <button class="arrow-btn" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">&#9664;</button>

      <button v-for="(page, index) in visiblePages" :key="index" class="num-btn"
        :class="{ active: currentPage === page }" @click="changePage(page)" :disabled="page === '...'">
        {{ page }}
      </button>

      <button class="arrow-btn" @click="changePage(currentPage + 1)"
        :disabled="currentPage === totalPages">&#9654;</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allPosts: [
        { id: 1, category: 'Fraud Counsel Department', title: 'How Professional Crypto Recovery Firms Work (And How to Spot Fake Ones)', excerpt: 'How Professional Crypto Recovery Firms Work (And How to Spot Fake Ones) As cryptocurrency fraud continues to rise, so does another dangerous threat: fake crypto recovery services. Many scam victims, desperate to reclaim lost funds, unknowingly fall into a second trap—one that promises fast results, guaranteed refunds, and insider access', date: 'January 30, 2026', url: '/how-professional-crypto-recovery-firms-work-and-how-to-spot-fake-ones' },
        { id: 2, category: 'Fraud Counsel Department', title: 'What Do I Immediately After a Crypto Scam: A Step-by-Step Recovery Guide', excerpt: 'What Do I Immediately After a Crypto Scam: A Step-by-Step Recovery Guide The minutes, hours, and days after discovering a crypto scam are critical. What you do next can preserve recovery options—or permanently close them. Unfortunately, many victims act on panic, misinformation, or well-meaning but harmful advice, unintentionally helping scammers', date: 'January 30, 2026', url: '/what-to-do-immediately-after-a-crypto-scam-a-step-by-step-recovery-guide' },
        { id: 3, category: 'Scam Alerts', title: 'Crypto Scam Recovery in 2026: New Threats, New Laws, and New Hope for Victims', excerpt: 'Crypto Scam Recovery in 2026: New Threats, New Laws, and New Hope for Victims Cryptocurrency fraud is not standing still—and neither is recovery. As we move deeper into 2026, scammers are evolving their tactics, exploiting new technologies, and adapting to increased awareness. At the same time, laws, compliance frameworks, and [...]', date: 'January 30, 2026', url: '/crypto-scam-recovery-in-2026-new-threats-new-laws-and-new-hope-for-victims' },
        { id: 4, category: 'Fraud Counsel Department', title: 'Tracing USDT, Bitcoin, and Ethereum: How Investigators Follow Digital Money', excerpt: 'Tracing USDT, Bitcoin, and Ethereum: How Investigators Follow Digital Money One of the most persistent myths in cryptocurrency fraud is that once funds are moved away into the blockchain forever. In reality, Bitcoin, Ethereum, and USDT are among the most traceable financial instruments ever created. Every transaction leaves a [...]', date: 'January 30, 2026', url: '/tracing-usdt-bitcoin-and-ethereum-how-investigators-follow-digital-money' },
        { id: 5, category: 'Fraud Counsel Department', title: 'The Emotional Fallout of Crypto Fraud—and Why Recovery Is More Than Money', excerpt: 'The Emotional Fallout of Crypto Fraud—and Why Recovery Is More Than Money When people talk about cryptocurrency fraud, they usually focus on numbers: how much was stolen, how fast it happened, or which coin was involved. But for victims, the most lasting damage is rarely financial alone. Crypto fraud leaves emotional [...]', date: 'January 30, 2026', url: '/the-emotional-fallout-of-crypto-fraud-and-why-recovery-is-more-than-money' },
        { id: 6, category: 'Legal', title: 'From Blockchain to Courtroom: How Legal Orders Help Recover Stolen Cryptocurrency', excerpt: 'The intersection of law and blockchain technology is still evolving. This post explains the legal mechanisms you can use to force exchanges and wallets to freeze and return funds...', date: 'January 18, 2026', url: '/from-blockchain-to-courtroom-how-legal-orders-help-recover-stolen-cryptocurrency' },
        { id: 7, category: 'Guides', title: 'Why Most Crypto Scam Victims Fail to Recover Funds—and How to Avoid That Mistake', excerpt: 'Why Most Crypto Scam Victims Fail to Recover Funds—and How to Avoid That Mistake Cry...', date: 'January 15, 2026', url: '/why-most-crypto-scam-victims-fail-to-recover-funds-and-how-to-avoid-that-mistake' },
        { id: 8, category: 'Guides', title: 'Pig Butchering Crypto Scams Explained: Inside the Psychology, Deception, and the Path to Recovery', excerpt: 'Pig Butchering Crypto Scams Explained: Inside the Psychology, Deception, and the Path to Recovery...', date: 'January 12, 2026', url: '/pig-butchering-crypto-scams-explained-inside-the-psychology-deception-and-the-path-to-recovery' },
        { id: 9, category: 'Knowledge', title: 'Can Stolen Cryptocurrency Really Be Recovered? What Blockchain Evidence Reveals', excerpt: 'Can Stolen Cryptocurrency Really Be Recovered? What Blockchain Evidence Reveals When a victim comes to us, one of the first questions they ask is: "Can my funds really be recovered?"...', date: 'January 10, 2026' },
        { id: 10, category: 'News', title: 'When Crypto Theft Becomes a Life Crisis: How Victims Can Rebuild Financial Control', excerpt: 'When Crypto Theft Becomes a Life Crisis: How Victims Can Rebuild Financial Control Crypto theft is not just about the money—it is about the future...', date: 'January 8, 2026' },
        { id: 11, category: 'News', title: 'Pig Butchering Crypto Scams: How Victims Can Respond And Seek Help', excerpt: 'Pig Butchering Crypto Scams: How Victims Can Respond And Seek Help Understanding Pig Butchering Crypto Scams and How Victims Can Recover ![Cover Image Placeholder – Realistic image of a concerned individual reviewing crypto transactions with a fraud specialist] Pig butchering scams have become one of the most harmful and financially [...]', date: 'December 23, 2025' },
        {
          id: 12, category: 'News', title: 'Reclaiming Control After a Crypto Scam: What Victims Need to Know',
          excerpt: 'Reclaiming Control After a Crypto Scam: What Victims Need to Know Falling victim to a cryptocurrency scam can be overwhelming. Beyond the financial loss, many victims experience stress, confusion, and uncertainty about where to turn next. Crypto scams are deliberately sophisticated, often involving fake investment platforms, long-term grooming schemes, or [...]', date: 'January 8, 2026'
        },
        {
          id: 14, category: 'News', title: 'Understanding Crypto Recovery: What Scam Victims Need to Know Before Taking Action',
          excerpt: 'Understanding Crypto Recovery: What Scam Victims Need to Know Before Taking Action Losing cryptocurrency to a scam is not just a financial loss — it is a moment that disrupts confidence, stability, and trust. Many victims describe the experience as disorienting, confusing, and isolating. In the aftermath, people are often [...]', date: 'January 8, 2026'
        },
        {
          id: 15, category: 'News', title: 'Guiding Crypto Scam Victims Through Recovery & Asset Protection',
          excerpt: 'Guiding Crypto Scam Victims Through Recovery & Asset Protection For many cryptocurrency scam victims, the loss of funds is only part of the damage. What follows is often far more dangerous: uncertainty, fear, and exposure to further exploitation. At Fraud Counsel Department, we focus not only on recovery guidance, but [...]', date: 'January 8, 2026'
        },
        {
          id: 16, category: 'News', title: 'Tracing Stolen Cryptocurrency: How Blockchain Investigation Helps Scam Victims',
          excerpt: 'Tracing Stolen Cryptocurrency: How Blockchain Investigation Helps Scam Victims When cryptocurrency is stolen, many victims are immediately told the same thing:“Crypto can’t be traced.”“Once it’s gone, it’s gone forever.” This narrative is not only misleading — it actively benefits scammers. At Fraud Counsel Department, one of our most important roles [...]', date: 'January 8, 2026'
        },
        {
          id: 17, category: 'News', title: 'Crypto Scam Victims Are Not Alone — Recovery Starts With the Right Guidance',
          excerpt: 'Crypto Scam Victims Are Not Alone — Recovery Starts With the Right Guidance Every year, thousands of individuals lose cryptocurrency to scams that are engineered to look legitimate, professional, and trustworthy. These are not simple tricks or obvious fraud attempts. Modern crypto scams are carefully designed systems that exploit trust, [...]', date: 'January 8, 2026'
        },
        {
          id: 18, category: 'News', title: 'Helping Victims Recover Lost Cryptocurrency After Scams',
          excerpt: 'Helping Victims Recover Lost Cryptocurrency After Scams Cryptocurrency scams have become one of the most financially and emotionally damaging forms of fraud in the modern digital world. Every week, individuals from all walks of life contact us after losing Bitcoin, Ethereum, USDT, or other digital assets through fake investment platforms, [...]', date: ' December 22, 2025'
        },
        {
          id: 19, category: 'News', title: 'Fraud Counsel Department: Professional Cryptocurrency Scam Recovery & Fraud Investigation',
          excerpt: 'Fraud Counsel Department: Professional Cryptocurrency Scam Recovery & Fraud Investigation In today’s digital economy, financial fraud has evolved at an unprecedented pace. Cryptocurrency scams, online investment fraud, impersonation schemes, and sophisticated cybercrime operations continue to impact individuals and businesses worldwide. Victims are often left confused, distressed, and uncertain about whether [...]', date: 'December 17, 2025'
        },
        {
          id: 20, category: 'News', title: 'Crypto Scam Recovery for First-Time Investors',
          excerpt: 'Crypto Scam Recovery for First-Time Investors A Complete Guide to Protecting Yourself, Understanding Blockchain Forensics, and Reclaiming What You Lost For many first-time investors, cryptocurrency represents possibility. It feels modern, borderless, and full of potential. Stories of early adopters, rapid gains, and financial independence create the sense that crypto is [...]', date: 'December 17, 2025'
        },
        {
          id: 21, category: 'News', title: 'How Blockchain Forensics Helps Recover Stolen Cryptocurrency',
          excerpt: 'How Blockchain Forensics Helps Recover Stolen Cryptocurrency Tracing digital assets once they’ve vanished into the maze of crypto wallets can feel like trying to follow footprints through a storm. Yet despite the impression that blockchain theft is irreversible, specialists are increasingly using advanced investigative techniques to Recover Stolen Cryptocurrency and [...]', date: 'January 8, 2026'
        },
        {
          id: 23, category: 'News', title: 'Lost Your Bitcoin? The Hard Truth & Limited Hopes of Recovery in 2025',
          excerpt: 'Lost Your Bitcoin? The Hard Truth & Limited Hopes of Recovery in 2025 Understanding Self-Custody Loss vs. Crypto Theft (A Blockchain-Level Perspective) The world of cryptocurrency was built on a powerful promise: self-sovereignty, decentralization, and total control over your wealth. No banks. No borders. No intermediaries. Just you and the [...]', date: ' November 23, 2025'
        },
        {
          id: 24, category: 'News', title: 'Reclaiming More Than Just Assets: The Human Cost of Crypto Fraud and Our Path to Recovery at the Fraud Counsel Department',
          excerpt: 'Reclaiming More Than Just Assets: The Human Cost of Crypto Fraud and Our Path to Recovery at the Fraud Counsel Department H1: From Devastation to Deliverance: How the Fraud Counsel Department Restores Hope and Financial Security After Crypto Theft The headlines often focus on the astronomical figures – billions lost [...]', date: 'November 18, 2025'
        },
        {
          id: 25, category: 'News', title: 'Beyond the Breach: How the Fraud Counsel Department Delivers Justice in the Age of Digital Asset Theft',
          excerpt: 'Beyond the Breach: How the Fraud Counsel Department Delivers Justice in the Age of Digital Asset Theft H1: Recovering What’s Lost: The Relentless Pursuit of Justice and the Advanced Methods of the Fraud Counsel Department in Crypto Recovery The rapid ascent of decentralized finance (DeFi) has brought unprecedented opportunities, but [...]', date: 'January 8, 2026'
        },
        {
          id: 26, category: 'News', title: 'The Ultimate Guide to Recovering From a Crypto Fraud or Fake Investment Scam: What Every Victim Must Know',
          excerpt: 'The Ultimate Guide to Recovering From a Crypto Fraud or Fake Investment Scam: What Every Victim Must Know Cryptocurrency has opened the door to financial freedom for millions of people — but it has also created the perfect environment for sophisticated online fraud. Scam platforms now look more realistic than [...]', date: 'January 8, 2026'
        },
        {
          id: 27, category: 'News', title: 'How to Recover From Fraud or a Fake Investment in 2025: A Deep, Practical Guide for Victims',
          excerpt: 'How to Recover From Fraud or a Fake Investment in 2025: A Deep, Practical Guide for Victims Falling victim to fraud is one of the most emotionally draining experiences anyone can face. Whether it happens through a fake investment platform, a deceptive cryptocurrency scheme, or a smooth-talking “advisor,” the sense [...]', date: 'January 8, 2026'
        },
        {
          id: 28, category: 'News', title: 'The 2025 Global Fraud Crisis: How Victims Can Reclaim Control With Professional Digital Asset Recovery',
          excerpt: 'The 2025 Global Fraud Crisis: How Victims Can Reclaim Control With Professional Digital Asset Recovery The year 2025 has introduced one of the most challenging eras for digital safety. With global financial activity shifting deeper into online platforms, cryptocurrencies, digital trading systems, and virtual payment applications, fraud schemes have evolved [...]', date: 'January 8, 2026'
        },
        {
          id: 29, category: 'News', title: 'Recovering From Online Financial Fraud in 2025: What Victims Need to Know (Fraud Counsel Department Guide)',
          excerpt: 'Recovering From Online Financial Fraud in 2025: What Victims Need to Know (Fraud Counsel Department Guide) Online financial fraud has evolved drastically over the past few years, and 2025 has seen a major surge in sophisticated scams across cryptocurrency, investment platforms, payment apps, and digital trading schemes. As criminals adopt [...]', date: 'January 8, 2026'
        },
        {
          id: 30, category: 'News', title: 'Inside the World of Crypto Fraud: How Bitcoin Scams Work and How Fraud Counsel Department Helps Victims Recover Their Assets',
          excerpt: 'Inside the World of Crypto Fraud: How Bitcoin Scams Work and How Fraud Counsel Department Helps Victims Recover Their Assets Cryptocurrency has unlocked a new era of financial freedom, but it has also created one of the fastest-growing criminal industries in the world: crypto fraud.Every day, people lose Bitcoin, Ethereum, [...]', date: 'January 8, 2026'
        },
        {
          id: 31, category: 'News', title: 'The Truth About Cryptocurrency Safety: How to Protect Your Bitcoin and Recover From Crypto Fraud with Fraud Counsel Department',
          excerpt: 'The Truth About Cryptocurrency Safety: How to Protect Your Bitcoin and Recover From Crypto Fraud with Fraud Counsel Department Cryptocurrency has become one of the most powerful financial innovations of our time. Bitcoin, Ethereum, USDT, and thousands of digital assets now move across global markets every second, creating opportunities—but also [...]', date: 'January 8, 2026'
        },
        {
          id: 32, category: 'News', title: 'Recover from Online Fraud in 2025/2026 with Fraud Counsel Department',
          excerpt: 'Recover from Online Fraud in 2025/2026 with Fraud Counsel Department Online financial crime has surged dramatically in recent years, targeting individuals, businesses, and global investors. Cryptocurrency fraud, online investment scams, impersonation schemes, and unauthorized withdrawal attacks have become increasingly sophisticated. These losses often happen in seconds — but the emotional, [...]', date: ' November 17, 2025'
        },
        {
          id: 33, category: 'News', title: 'How to Reclaim Financial Control After a Crypto Scam: A Complete 2025 Recovery Guide',
          excerpt: 'How to Reclaim Financial Control After a Crypto Scam: A Complete 2025 Recovery Guide Cryptocurrency offers limitless opportunity — but it has also become one of the most targeted spaces for fraud and cybercrime. In 2025, billions of dollars are lost each year to fake exchanges, phishing wallets, impersonation scams, [...]', date: ' November 14, 2025'
        },
        {
          id: 34, category: 'News', title: 'Understanding Wallet Security: How to Keep Your Cryptocurrency Safe from Hackers in 2025',
          excerpt: 'Understanding Wallet Security: How to Keep Your Cryptocurrency Safe from Hackers in 2025 Cryptocurrency represents financial independence — but it also brings personal responsibility. As global adoption increases, cybercriminals are targeting digital wallets with new levels of sophistication. In 2025, protecting your crypto isn’t just about choosing the right platform [...]', date: 'November 14, 2025'
        },
        {
          id: 35, category: 'News', title: 'Navigating the Future of Digital Asset Security: How to Protect Your Cryptocurrency in 2025',
          excerpt: 'Navigating the Future of Digital Asset Security: How to Protect Your Cryptocurrency in 2025 Cryptocurrency continues to reshape global finance — but with innovation comes risk. In 2025, digital assets face more sophisticated threats than ever before, from advanced phishing networks to deepfake impersonations and artificial-intelligence-driven fraud. At Fraud Counsel [...]', date: 'November 14, 2025'
        },
        {
          id: 36, category: 'News', title: 'The Psychology of Crypto Scams: Why Smart Investors Still Fall Victim',
          excerpt: 'The Psychology of Crypto Scams: Why Smart Investors Still Fall Victim Cryptocurrency has revolutionized the financial world by offering independence, privacy, and profit potential unlike any traditional system. But behind the innovation lies a growing psychological battleground — where fraudsters use emotional and behavioral manipulation to exploit even the [...]', date: 'November 14, 2025'
        },
        {
          id: 37, category: 'News', title: 'The Legal Side of Cryptocurrency Recovery: What Victims Should Know in 2025',
          excerpt: 'The Legal Side of Cryptocurrency Recovery: What Victims Should Know in 2025 Cryptocurrency’s global rise has brought both innovation and exploitation. While blockchain technology was built to enhance transparency and independence, it has also created opportunities for cybercriminals who hide behind anonymity. When digital assets are stolen, recovery isn’t just [...]', date: 'November 14, 2025'
        },
        {
          id: 39, category: 'News', title: ' How to Identify Legitimate Crypto Recovery Services in 2025', excerpt: 'How to Identify Legitimate Crypto Recovery Services in 2025 The cryptocurrency recovery industry has grown alongside the rise in digital fraud. Unfortunately, not every company offering “crypto recovery” is legitimate. In fact, many scammers now pose as recovery specialists — preying on victims who have already been scammed once. For [...]', date: 'November 14, 2025'
        },
        {
          id: 40, category: 'News', title: 'Recover From a Crypto Scam Today With Fraud Counsel Department',
          excerpt: 'Recover From a Crypto Scam Today With Fraud Counsel Department As cryptocurrency continues to shape global finance, it has also opened new doors for cybercriminals. Every day, investors fall victim to fraudulent trading platforms, impersonation schemes, and blockchain-related scams. The good news is that recovery is possible when guided by [...]', date: 'November 14, 2025'
        },
      ],
      archives: ['January 2026', 'December 2025', 'November 2025'],
      currentPage: 1,
      postsPerPage: 8
    };
  },
  computed: {
    // 计算当前页显示的文章 (保留分页联动)
    paginatedPosts() {
      const start = (this.currentPage - 1) * this.postsPerPage;
      const end = start + this.postsPerPage;
      return this.allPosts.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.allPosts.length / this.postsPerPage);
    },
    recentPosts() {
      return this.allPosts.slice(0, 3);
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i);
        return pages;
      }
      pages.push(1);
      if (this.currentPage > 3) pages.push('...');
      for (let i = Math.max(2, this.currentPage - 1); i <= Math.min(total - 1, this.currentPage + 1); i++) {
        pages.push(i);
      }
      if (this.currentPage < total - 2) pages.push('...');
      pages.push(total);
      return pages;
    }
  },
  methods: {
    changePage(page) {
      if (page === '...' || page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    navTo(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>
.blog-section {
  background-color: #0b0b0f;
  padding-bottom: 50px;
  padding-top: 50px;
}

.blog-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 50px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 40px;
}

/* 左侧文章样式 */
.post-card {
  background: #12151c;
  border: 1px solid #222;
  border-radius: 8px;
  padding: 30px;
  margin-bottom: 30px;
  transition: transform 0.2s;
}

.post-card:hover {
  transform: translateY(-3px);
  border-color: #333;
}

.post-header {
  display: flex;
  align-items: center;
  gap: 25px;
  margin-bottom: 20px;
  font-size: 0.85rem;
  color: #888;
}

.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* SVG图标颜色 */
.meta-item svg {
  color: #8e2de2;
}

.post-title {
  font-size: 1.8rem;
  margin: 0 0 15px;
  line-height: 1.3;
  color: #fff;
}

.post-excerpt {
  color: #aaa;
  line-height: 1.6;
  margin-bottom: 20px;
}

.read-more {
  background: #8e2de2;
  color: #fff;
  border: none;
  padding: 10px 25px;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 600;
}

.read-more:hover {
  opacity: 0.8;
}

/* 右侧侧边栏 */
.sidebar-box {
  background: #12151c;
  border: 1px solid #222;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 25px;
}

.sidebar-box h3 {
  font-size: 0.9rem;
  margin: 0 0 15px;
  border-bottom: 1px solid #333;
  padding-bottom: 10px;
  color: #fff;
  letter-spacing: 1px;
}

.link-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-list li {
  padding: 10px 0;
  border-bottom: 1px solid #222;
  cursor: pointer;
  color: #373636;
  font-size: 0.9rem;
}

.link-list li:hover {
  color: #8e2de2;
}

.link-list li:last-child {
  border-bottom: none;
}

.empty-text {
  color: #888;
  font-size: 0.9rem;
  margin: 0;
}

/* 搜索框样式 */
.search-bar {
  display: flex;
}

.search-bar input {
  flex: 1;
  background: #1a1e26;
  border: 1px solid #333;
  border-right: none;
  padding: 10px;
  color: #fff;
  outline: none;
  border-radius: 4px 0 0 4px;
}

.search-bar button {
  background: #8e2de2;
  border: none;
  color: #fff;
  padding: 0 15px;
  cursor: pointer;
  border-radius: 0 4px 4px 0;
}

/* 底部分类列表 */
.link-list.with-date .post-title-sm {
  font-size: 0.9rem;
  color: #fff;
  margin-bottom: 5px;
}

.link-list.with-date .post-date-sm {
  font-size: 0.75rem;
  color: #666;
}

.count {
  color: #888;
  margin-left: 5px;
}

/* 分页器样式 (保留联动功能) */
.pagination-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 20px 0;
}

.num-btn,
.arrow-btn {
  width: 40px;
  height: 40px;
  background: #12151c;
  border: 1px solid #333;
  color: #aaa;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.num-btn:hover:not(:disabled),
.arrow-btn:hover:not(:disabled) {
  color: #fff;
  border-color: #8e2de2;
}

.num-btn.active {
  background: #8e2de2;
  color: #fff;
  border-color: #8e2de2;
}

.num-btn:disabled,
.arrow-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 响应式适配 */
@media (max-width: 900px) {
  .blog-container {
    grid-template-columns: 1fr;
  }

  .sidebar {
    order: 2;
  }

  .post-title {
    font-size: 1.4rem;
  }
}
</style>